<template lang="pug">
#home
  custom-header
  page-content
  cards
  custom-form
  sponsor
  custom-footer
</template>

<script>
import CustomHeader from "@/components/home/Header";
import PageContent from "@/components/home/PageContent";
import Cards from "@/components/home/Cards";
import CustomForm from "@/components/home/Form";
import Sponsor from "@/components/home/Sponsor";
import CustomFooter from "@/components/common/Footer";

export default {
  name: "Home",
  components: {
    "custom-header": CustomHeader,
    "page-content": PageContent,
    cards: Cards,
    "custom-form": CustomForm,
    sponsor: Sponsor,
    "custom-footer": CustomFooter,
  },
};
</script>
